import React from "react";
import "./index.less";
class IsefcFooter extends React.Component {
  render() {
    return (
      <div className="center_footer">
        <footer className="p-isefc_footer">
          <div className="p-isefc-center">
            <span>主办单位：中华国际科学交流基金会</span>
            <span style={{marginLeft:"91px"}}>咨询电话：010-88653180</span>
            <span>咨询邮箱：stsc@isefc.org</span>
          </div>
          <div className="p-isefc-center">
            <span>协办单位：中关村天合科技成果转化促进中心</span>
            <span style={{marginLeft:"33px"}}>咨询电话：010-88192046</span>
            <span>咨询邮箱：thkj@techchina.org.cn</span>
          </div>
          <div className="p-isefc-center">
            <span>技术支持：北京天合育成科技服务有限责任公司</span> 
            <span>备案号：京ICP备16027592号-3</span>
          </div>
        </footer>
      </div>
    );
  }
};

export default IsefcFooter;
